import {
  FETCH_REFERRAL_BY_CODE_REQUEST,
  FETCH_REFERRAL_BY_CODE_SUCCESS,
  FETCH_REFERRAL_BY_CODE_FAILURE,
  FETCH_USER_REFERRALS_REQUEST,
  FETCH_USER_REFERRALS_SUCCESS,
  FETCH_USER_REFERRALS_FAILURE,
} from "../actions/referralActions";

const initialState = {
  referralData: null,
  userReferrals: [],
  loading: false,
  error: null,
};

const referralReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REFERRAL_BY_CODE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_REFERRAL_BY_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        referralData: action.payload,
        error: null,
      };
    case FETCH_REFERRAL_BY_CODE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        referralData: null,
      };
    case FETCH_USER_REFERRALS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_USER_REFERRALS_SUCCESS:
      return {
        ...state,
        loading: false,
        userReferrals: action.payload,
        error: null,
      };
    case FETCH_USER_REFERRALS_FAILURE:
      return {
        ...state,
        loading: false,
        userReferrals: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default referralReducer;
